import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class RefrigerantBus extends BaseBus{

    constructor(busObj: RefrigerantBus) {
        super(busObj);

    }
    CID(): any {
        return this.refrigerantPriceId;
    }
    setId(id: any) {
        this.refrigerantPriceId = id;
    }
    setParentId(id: any) {
        // this.bidDetailID = id;
    }
    initialize(data: RefrigerantBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: RefrigerantBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    refrigerantPriceId:string;
    type:string;
    price:number;
    insertDt:Date;
    updateDt:Date;
    insertUserId:string;
    updateUserId:string;
     bidDetailID : string;
    // componentID :string;
    // bidDetailID : string;
    // catogory  : string;
    // type : string;
    // qty : number;
    // material:string;
    // pipeFitter:number;
    // caseSetter:number;
    // labor:number;
    // remark:string;
    // compInsertDt:Date;
    // categoryDesc:Date;
    // categoryTypeDesc:string;
    // categoryName:string;
    // categoryTypeName:string
    // insertDt: Date;
    // updateDt: Date;
    // compUpdateDt: string;
    // compUpdateUserId:string;
    // compInsertUserId : string;
}